import getProductVariant from './getProductVariant';
export default function getYearName(year) {
  const variant = getProductVariant();
  if (variant.url === 'dashboard.edrian.co.uk')
    return year?.scottishName || year?.name;
  if (variant.url === 'dashboard.traciwr.com' && year?.name === 'EYFS')
    return 'R';
  return year?.name;
}
